module.exports = __webpack_public_path__ + "static/media/St Georges Road Alcove Unit (9).90aa43e5.jpg";